import { lazy, Suspense, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { ProtectedRoute } from './components/ProtectedRoute'

const AppShell = lazy(() => import('./components/AppShell').then(module => ({ default: module.AppShell })))
const Landing = lazy(() => import('./pages/Landing'))
const Login = lazy(() => import('./pages/Login'))
const Home = lazy(() => import('./pages/Home'))
const Explore = lazy(() => import('./pages/Explore'))
const Library = lazy(() => import('./pages/Library'))
const Community = lazy(() => import('./pages/Community'))
const BookDetail = lazy(() => import('./pages/BookDetail'))
const Reader = lazy(() => import('./pages/Reader'))
const Profile = lazy(() => import('./pages/Profile'))
const Legal = lazy(() => import('./pages/Legal'))
const ClubDetail = lazy(() => import('./pages/ClubDetail'))
const NotFound = lazy(() => import('./pages/NotFound'))
const BookStudio = lazy(() => import('./pages/BookStudio'))
const BookEditor = lazy(() => import('./pages/BookEditor'))
const Friends = lazy(() => import('./pages/Friends'))

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'auto' }) }, [pathname])
  return null
}

export default function App() {
  return <Suspense fallback={<div className="route-loading" role="status"><span className="route-spinner"/>Preparando o LIVROOM…</div>}><ScrollToTop/><Routes>
    <Route path="/" element={<Landing/>}/>
    <Route path="/login" element={<Login/>}/>
    <Route path="/terms" element={<Legal/>}/><Route path="/privacy" element={<Legal/>}/><Route path="/guidelines" element={<Legal/>}/>
    <Route element={<ProtectedRoute/>}>
      <Route path="/app" element={<AppShell/>}>
        <Route index element={<Home/>}/><Route path="explore" element={<Explore/>}/><Route path="library" element={<Library/>}/><Route path="studio" element={<BookStudio/>}/><Route path="studio/:id" element={<BookEditor/>}/><Route path="community" element={<Community/>}/><Route path="community/club/:id" element={<ClubDetail/>}/><Route path="friends" element={<Friends/>}/><Route path="book/:id" element={<BookDetail/>}/><Route path="read/:id" element={<Reader/>}/><Route path="profile" element={<Profile/>}/>
      </Route>
    </Route>
    <Route path="*" element={<NotFound/>}/>
  </Routes></Suspense>
}
